// src/components/BacktestResults.tsx
import React from 'react';
import BacktestSummary from './BacktestSummary';
import type { TradeSummaryStats } from '../state/types';

export type BacktestSummaryPayload = {
  constant_hold_trades?: { [bars: number]: TradeSummaryStats };
  exit_on_first_profit_trades?: TradeSummaryStats;
  expression_hold?: TradeSummaryStats;
} | null;

interface BacktestResultsProps {
  summary: BacktestSummaryPayload;
}

const BacktestResults: React.FC<BacktestResultsProps> = ({ summary }) => {
  if (!summary) return null;

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold mb-2 font-headline">Backtest Results Summary</h2>
      <BacktestSummary summary={summary} />
    </div>
  );
};

export default BacktestResults;